"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var actions_1 = require("../../actions/actions");
var App_1 = require("../App/App");
var Filters_styled_1 = require("./Filters.styled");
var Filters = function () {
    var _a = react_1.useState({
        student: '',
        region: '',
    }), formData = _a[0], setFormData = _a[1];
    var config = react_1.useContext(App_1.GlobalContext);
    var handleChange = function (e) {
        var _a;
        var name = e.target.name;
        var value = e.target.value;
        setFormData(__assign(__assign({}, formData), (_a = {}, _a[name] = value, _a)));
    };
    var handleSubmit = function () {
        actions_1.fetchStudents(formData).then(function (resp) {
            if (config.updateStudents) {
                config.updateStudents(resp.students);
            }
        });
    };
    return (react_1.default.createElement(Filters_styled_1.StyledFilterWrapper, null,
        react_1.default.createElement(Filters_styled_1.StyledColumn1, null,
            react_1.default.createElement(Filters_styled_1.StyledH2, null, "ACTIVITY COMPARISON")),
        react_1.default.createElement(Filters_styled_1.StyledForm, { inline: true, onSubmit: handleSubmit },
            react_1.default.createElement(Filters_styled_1.StyledRegionWrapper, null,
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Region"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "select", name: "region", onChange: handleChange },
                    react_1.default.createElement("option", { value: "" }, "All Regions"),
                    config.regions.map(function (region) {
                        return react_1.default.createElement("option", { value: region }, region);
                    }))),
            react_1.default.createElement(Filters_styled_1.StyledSearchWrapper, null,
                react_1.default.createElement(react_bootstrap_1.Form.Control, { name: "student", type: "text", value: formData.student, onChange: handleChange, placeholder: "Search name" })),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: handleSubmit }, "Search"))));
};
exports.default = Filters;
